export const rowTexts = {
    credited: {
        ru: 'начислено',
        en: 'credited'
    },
    hours: {
        ru: 'часов',
        en: 'hours'
    }
}